import Obs from "ulearning-obs/dist/obs-huawei.js";
export default Obs